import React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fff',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  '&:hover': {
    boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer',
  },
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: '#d0f8ce',
  },
  transition: 'transform 0.15s ',
}));

const SubInvoiceTable = ({
  soItem,
  isRowOpen,
  mainColumns,
  subColumns,
  selectedRows,
  setSelectedRows,
  renderCellContent,
}) => {
  const invoices = soItem.invoice || [];

  const handleSelectAllSubRows = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const newSelected = invoices.filter(
        (invoice) =>
          !selectedRows.some((r) => r.invoice_no === invoice.invoice_no),
      );
      setSelectedRows([...selectedRows, ...newSelected]);
    } else {
      setSelectedRows(
        selectedRows.filter(
          (r) =>
            !invoices.some((invoice) => invoice.invoice_no === r.invoice_no),
        ),
      );
    }
  };

  const isSelected = (row) =>
    selectedRows.some((selected) => selected.invoice_no === row.invoice_no);

  const handleSelectRow = (row) => {
    if (isSelected(row)) {
      setSelectedRows(
        selectedRows.filter((value) => value.invoice_no !== row.invoice_no),
      );
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };

  const numSelectedInThisSo = selectedRows.filter((r) =>
    invoices.some((invoice) => invoice.invoice_no === r.invoice_no),
  ).length;

  const isAllSubRowsSelected =
    invoices.length > 0 && numSelectedInThisSo === invoices.length;
  const isSubRowsIndeterminate =
    numSelectedInThisSo > 0 && numSelectedInThisSo < invoices.length;

  return (
    <TableRow>
      <TableCell
        style={{ paddingBottom: 0, paddingTop: 0 }}
        colSpan={mainColumns.length + 2}
      >
        <Collapse in={isRowOpen} timeout="0" unmountOnExit>
          <Box sx={{ margin: 2, overflowX: 'auto' }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#BEBEBE' }}>
                  <TableCell
                    padding="checkbox"
                    sx={{
                      fontWeight: 'bold',
                      position: 'sticky',
                      left: 0,
                      zIndex: 10,
                      backgroundColor: '#BEBEBE',
                    }}
                  >
                    <Checkbox
                      indeterminate={isSubRowsIndeterminate}
                      checked={isAllSubRowsSelected}
                      onChange={handleSelectAllSubRows}
                      color="default"
                    />
                  </TableCell>

                  {subColumns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      sx={{
                        fontWeight: 'bold',
                        minWidth: column.minWidth,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {invoices.length > 0 ? (
                  invoices.map((invoice, invIndex) => {
                    const rowIsSelected = isSelected(invoice);
                    return (
                      <StyledTableRow
                        key={invoice.invoice_no || invIndex}
                        selected={rowIsSelected}
                      >
                        <TableCell
                          padding="checkbox"
                          sx={{
                            zIndex: 1,
                            backgroundColor: '#EEE9E9',
                          }}
                        >
                          <Checkbox
                            checked={rowIsSelected}
                            onChange={() => handleSelectRow(invoice)}
                          />
                        </TableCell>

                        {subColumns.map((column) => {
                          const dataToRender =
                            column.id === 'so_number' ||
                            column.id === 'quotation' ||
                            (column.id === 'customer_name' && soItem.customer)
                              ? soItem
                              : invoice;

                          return (
                            <TableCell
                              key={column.id + invIndex}
                              align={column.align}
                              sx={{
                                backgroundColor: '#EEE9E9',
                              }}
                            >
                              {/* เรียกใช้ renderCellContent ที่ส่งมาจากตัวแม่ตัวมัม:p */}
                              {renderCellContent(column.id, dataToRender, true)}
                            </TableCell>
                          );
                        })}
                      </StyledTableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={subColumns.length + 1}
                      align="center"
                      sx={{ color: 'grey.500' }}
                    >
                      ไม่มีรายการ Invoice สำหรับ Sales Order นี้
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default SubInvoiceTable;
